<!-- token管理-->
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form
        class="ant-advanced-search-form"
        layout="inline"
        :form="form"
        @submit="handleSearch"
      >
        <a-row :gutter="24">
          <a-col :md="6" :sm="8">
            <a-form-item label="系统名称">
              <a-input
                placeholder="请输入系统名称"
                v-model="queryParam.systemName"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="系统代码">
              <a-input
                placeholder="请输入系统代码"
                v-model="queryParam.systemCode"
              ></a-input>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleSearch" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="handleReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>
      <a-table
        size="middle"
        bordered
        :columns="columns"
        :data-source="dataList"
        rowKey="id"
        :scroll="{ x: 1000 }"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange
        }"
        @change="handleTableChange"
      >
        <span slot="operation" slot-scope="text, record">
          <a @click="unLine(record)">下线</a>
        </span>
      </a-table>
    </div>
  </a-card>
</template>

<script>
import { getAction } from '@/api/manage';
const columns = [
  {
    align: 'center',
    title: '系统名',
    dataIndex: 'systemName',
    width: 200
  },
  {
    align: 'center',
    title: '系统代码',
    dataIndex: 'systemCode',
    width: 200
  },
  {
    align: 'center',
    title: 'token创建时间',
    dataIndex: 'createTime',
    width: 200
  },
  {
    align: 'center',
    title: 'token失效时间(秒）',
    dataIndex: 'expireTime',
    width: 200
  },
  {
    align: 'center',
    title: '操作',
    key: 'operation',
    width: 200,
    scopedSlots: {
      customRender: 'operation'
    }
  }
];
export default {
  data() {
    return {
      ipagination: {
        //分页参数
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      columns,
      form: this.$form.createForm(this),
      expand: false,
      selectedRowKeys: [],
      selectedRows: [],
      dataList: [],
      loading: false,
      url: {
        list: process.env.VUE_APP_CMS_SYSTEM + '/sys/auth/token/page',
        remove: process.env.VUE_APP_CMS_SYSTEM + '/sys/auth/token/remove'
      },
      queryParam: {
        systemCode: '',
        systemName: ''
      }
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      let params = {
        ...this.queryParam,
        pageNo: this.ipagination.current,
        pageSize: this.ipagination.pageSize
      };
      this.loading = true;
      getAction(this.url.list, params).then(res => {
        console.log(res, '++++++++');
        this.loading = false;
        if (res.success) {
          this.dataList =
            res.result && res.result.records ? res.result.records : [];
          this.ipagination.total = res.result ? res.result.total : 0;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleSearch() {
      this.initData();
    },
    handleReset() {
      this.queryParam = {
        systemCode: '',
        systemName: ''
      };
      this.initData();
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRows = selectionRows;
      this.selectedRowKeys = selectedRowKeys;
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected();
      this.ipagination = pagination;
      this.initData();
    },
    unLine(record) {
      let that = this;
      this.$confirm({
        title: '确认下线',
        content: '是否下线选中数据?',
        onOk() {
          let params = {
            accessToken: record.accessToken
          };
          getAction(that.url.remove, params).then(res => {
            if (res.success) {
              that.$message.success(res.message);
              that.initData();
            } else {
              that.$message.error(res.message);
            }
          });
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.table-operator {
  margin-bottom: 10px;
}
</style>
